<template>
    <NuxtLayout name="malt-base-layout">
        <main>
            <VJoyFunnel
                data-testid="service-level-funnel"
                class="service-level"
                :class="{'service-level-page': isServiceLevelPage}"
                :layout-width="isServiceLevelPage ? 'large' : 'medium'"
            >
                <template #funnel-header>
                    <VJoyFunnelHeader>
                        <template #funnel-header-right>
                            <NuxtLink v-slot="{navigate, href}" :to="dropRedirect || '/'" external custom>
                                <VJoyButton
                                    v-if="dropButtonText"
                                    :label="dropButtonText"
                                    size="medium"
                                    variant="ghost"
                                    data-testid="service-level-funnel-drop-text-button"
                                    :href="href"
                                    @click="navigate"
                                />
                                <VJoyIconButton
                                    v-else
                                    :title="$t('general.close')"
                                    size="medium"
                                    icon="cross"
                                    variant="ghost"
                                    data-testid="service-level-funnel-drop-cross-icon"
                                    :href="href"
                                    @click="navigate"
                                />
                            </NuxtLink>
                        </template>
                    </VJoyFunnelHeader>
                </template>

                <VJoyTemplate>
                    <template #template-title>
                        <slot name="title" />
                    </template>
                    <template #template-main>
                        <slot name="main" />
                        <VJoyFunnelFooter v-if="!isServiceLevelPage && !isEnterpriseRequestReceivedPage">
                            <template #footer-left>
                                <VJoyButton
                                    :label="t('service-level.footer.back.button')"
                                    size="small"
                                    variant="secondary"
                                    @click="onPreviousClick"
                                />
                            </template>
                            <template #footer-right>
                                <slot name="footer-right" />
                            </template>
                        </VJoyFunnelFooter>
                    </template>
                </VJoyTemplate>
            </VJoyFunnel>
        </main>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {computed, useRoute, useTranslation} from '#imports';
    import {VJoyButton, VJoyFunnel, VJoyFunnelFooter, VJoyFunnelHeader, VJoyIconButton, VJoyTemplate} from '@maltjoy/core-vue';
    import {ServiceLevelType} from '~/openapi/models';
    import {eventBus} from '@/common/service-level/events';
    import {useRedirectParamsStore} from '@/store/redirect-params.store';
    import {useServiceLevelStateStore} from '@/store/service-level-state.store';

    const route = useRoute();
    const {t} = useTranslation();

    const organizationId = computed(() => route.params.id as string);

    const serviceLevelStateStore = useServiceLevelStateStore();
    const {setPageSource} = serviceLevelStateStore;
    const {currentPlan, pageSource} = storeToRefs(serviceLevelStateStore);

    const redirectParamsStore = useRedirectParamsStore();
    const {dropRedirect} = storeToRefs(redirectParamsStore);
    const {setRedirectUrl} = redirectParamsStore;

    setPageSource();
    setRedirectUrl();

    const dropButtonText = computed(() => {
        if (pageSource.value === 'signup' && currentPlan.value === ServiceLevelType.Standard) {
            return t('service-level.continue.as.starter.button');
        }

        return undefined;
    });

    const isServiceLevelPage = computed(() => route.path === `/organization/${organizationId.value}/service-level`);
    const isEnterpriseRequestReceivedPage = computed(
        () => route.path === `/organization/${organizationId.value}/service-level/enterprise-request-received`,
    );
    function onPreviousClick() {
        eventBus.emit('funnel:previous:click');
    }
</script>
